/**
 * Route definition for /create-item
 * Renders the CreateItemContainer (ListItem container) component.
 *
 * @module routes/create-item
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import CreateItemContainer from '@/containers/ListItem'

export const Route = createFileRoute('/$locale/create-item')({
  component: CreateItem,
})

/**
 * Create item page component.
 * Renders the ListItem container for creating new NFT listings.
 *
 * @returns {React.ReactElement}
 */
function CreateItem() {
  return (
    <>
      <CreateItemContainer/>
    </>
  )
}